export default __webpack_public_path__ + "img/dwZUTBwn.e0f467c1.svg";